"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VisionPrescription = void 0;
/**
 * An authorization for the provision of glasses and/or contact lenses to a patient.
 */
var VisionPrescription = /** @class */ (function () {
    function VisionPrescription() {
    }
    return VisionPrescription;
}());
exports.VisionPrescription = VisionPrescription;
